import { Link } from 'react-router-dom';
import { footerLinks, socialLinks } from '@/mocks/nav';

export default function Footer() {
  return (
    <footer className="bg-background-200/70 border-t border-background-200/70">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8 lg:gap-12">
          <div>
            <Link to="/" className="inline-block mb-4">
              <span className="text-xl font-heading font-bold text-foreground-900">蜜桃传媒</span>
            </Link>
            <p className="text-sm text-foreground-600 leading-relaxed max-w-xs">
              专注优质内容创作与传播的媒体平台，汇聚海量精品内容资源，为用户提供极致娱乐体验。
            </p>
            <div className="flex items-center gap-3 mt-4">
              {socialLinks.map((social) => (
                <a
                  key={social.label}
                  href={social.url}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="w-9 h-9 flex items-center justify-center rounded-full bg-background-100 text-foreground-600 hover:text-primary-500 hover:bg-primary-50 transition-colors duration-200 cursor-pointer"
                  aria-label={social.label}
                >
                  <i className={`${social.icon} text-base`} />
                </a>
              ))}
            </div>
          </div>

          {[footerLinks.platform, footerLinks.categories, footerLinks.support].map((section) => (
            <div key={section.title}>
              <h4 className="text-sm font-semibold text-foreground-900 mb-4">{section.title}</h4>
              <ul className="flex flex-col gap-2.5">
                {section.links.map((link) => (
                  <li key={link.label}>
                    <Link
                      to={link.path}
                      className="text-sm text-foreground-600 hover:text-primary-500 transition-colors duration-200 whitespace-nowrap cursor-pointer"
                    >
                      {link.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}
        </div>

        <div className="mt-12 pt-6 border-t border-background-300/60 flex flex-col sm:flex-row items-center justify-between gap-3">
          <p className="text-xs text-foreground-500">
            &copy; 2026 蜜桃传媒 版权所有 | 京ICP备2024XXXXXXXX号
          </p>
          <div className="flex items-center gap-4">
            <Link to="/about" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap cursor-pointer">隐私政策</Link>
            <Link to="/about" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap cursor-pointer">用户协议</Link>
            <Link to="/about" className="text-xs text-foreground-500 hover:text-foreground-700 transition-colors whitespace-nowrap cursor-pointer">内容规范</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}